import { createActions } from 'redux-actions';

import types from 'state/auth/actionTypes';

const { auth } = createActions({
  [types.SET_LOADING]: (loading) => ({ loading }),
  [types.SET_USER]: (user) => ({ user }),
  [types.SET_SHIPPER]: ({ shipper }) => ({ shipper }),
  [types.SET_CREDENTIALS]: (credentials) => ({ credentials }),
  [types.SET_ERROR]: (error = '') => ({ error }),

  [types.sendUserInvitation$]: ({ invitationUserData }) => ({
    invitationUserData,
  }),
  [types.updateUser$]: ({ userData }) => ({ userData }),
  [types.login$]: ({ username, password }) => ({ username, password }),
  [types.signUp$]: ({ name, surname, password, userDataHash }) => ({
    name,
    surname,
    password,
    userDataHash,
  }),
  [types.logout$]: () => ({}),
});

export default auth;
